import { NavLink } from "react-router-dom"
import { MANAGE_TABS } from "../admin-const"

const AdminTabs = () => {
  return (
    <div className="flex items-center justify-center mb-5">
      {MANAGE_TABS.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) => `
            flex items-center justify-center
            flex-1 px-4 py-3
            border-b-2
            ${
              isActive
                ? "text-toicos-navy border-b-toicos-navy font-bold"
                : "border-b-slate-200 text-slate-600 hover:border-slate-300 font-medium"
            }
          `}
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  )
}

export default AdminTabs
